import * as moment from "moment";
import * as React from "react";
import { RenderCalendarEvent } from "source/app/presentation/MainPanel/Calendar/CalendarEvents/Render/RenderCalendarEvent";
import { FadeInArray } from "source/app/presentation/Shared/Animation/FadeInArray";
import { useIntervalToRerender } from "source/app/services/Shared/Hooks/useIntervalToRerender";
import { ICalendarEvent } from "../../../../../../../motw_core/Calendar/ICalendarEvent";
import { ICalendarState } from "../ICalendarState";
import * as styles from "./CalendarEvents.css";
import { ShowCurrentEventInHeader } from "./ShowCurrentEventInHeader";

export function CalendarEvents({
    calendarEvents,
    state,
}: {
    calendarEvents: ICalendarEvent[];
    state: ICalendarState;
}) {
    // React.useEffect(() => SetCalendarNavigationBadge(), [completedEventIds]);

    const currentMinute = moment().minute();

    TempLogging(calendarEvents);

    React.useEffect(() => {
        ShowCurrentEventInHeader(calendarEvents);
    }, [calendarEvents, currentMinute]);

    useIntervalToRerender(20000);

    return (
        <div className={styles.calendar}>
            <FadeInArray
                label="calendarEvents"
                array={calendarEvents}
                render={(event) => (
                    <RenderCalendarEvent
                        {...{
                            hoursBeingChanged: state.hoursBeingChanged,
                            eventData: event,
                            key: event.name,
                        }}
                    />
                )}
                itemDelayMs={125}
            />
        </div>
    );
}
function TempLogging(calendarEvents: ICalendarEvent[]) {
    const completedEventTuples = calendarEvents
        .filter((ce) => ce.isCompleted)
        .map((ce) => ({
            name: ce.name,
            isCompleted: ce.isCompleted,
            completionEventId: ce.completionEventId,
        }));

    // console.log(`Completed calendar events: `, completedEventTuples);
}
